module.exports = __webpack_public_path__ + "img/girl_image.c49aa43a.png";